<div *ngIf="display" class="jumbotron mt-8 text-center p-15">
    <span class="m-loader--success m-loader--right m-loader">
        <span *ngIf="text">{{ text }}</span>
    </span>
</div>
